import { FormLabel } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export interface FileUploadFieldProps {
  label: string;
  accept: string;
  onChange: (files: FileList | null) => void;
  existingFiles?: string[];
}

export function FileUploadField({ 
  label, 
  accept, 
  onChange,
  existingFiles 
}: FileUploadFieldProps) {
  return (
    <div className="space-y-2">
      <FormLabel className="text-apple-dark">{label}</FormLabel>
      <Input
        type="file"
        accept={accept}
        onChange={(e) => onChange(e.target.files)}
        multiple
        className={cn(
          "rounded-apple",
          "bg-apple-light-gray/20 border-apple-light-gray/30",
          "file:bg-apple-blue file:text-white",
          "file:border-0 file:rounded-apple-sm",
          "file:px-4 file:py-2 file:mr-4",
          "hover:file:bg-apple-blue/90"
        )}
      />
      {existingFiles && existingFiles.length > 0 && (
        <div className="text-sm text-apple-gray">
          {existingFiles.length} existing {label.toLowerCase()}
        </div>
      )}
    </div>
  );
}